export const EXPO_CONFIG = {
    // nom de la taula de tesaurus i tld de la exposició a Dédalo
    table: 'ts_regresar_es_irse',
    tld: 'navarra496',

    // section_id del terme arrel del tesaurus
    rootId: 1,

    // section_id del terme que te com a fills les pàgines de la exposició en ordre
    chaptersParentId: 31,

    // nivell de profunditat on estan les pàgines de la exposició
    chaptersLevelsDeep: 2,

    // section_id dels termes de les pàgines especials
    specialPages: {
        timeline: 5,
        learnMore: 6,
        credits: 29,
        report: 30,
    },
};
